<template>
  <div>
    <div class="history l-container">
      <div class="flex flex-wrap">
        <div class="w-full">
          <h1>閲覧履歴</h1>
        </div>
      </div>
    </div>
    <div class="divider mt-4 mb-4"></div>
    <div class="history l-container">
      <div class="history-wrapper">
        <LeftMenuBar :navBars="navBars" />
        <div class="base-content">
          <a-card class="base-content-top">
            <div class="base-content-top-filter">
              <a-button class="b-button" @click="getSortResults">
                <span class="icon icon-bor-arrow-2-way mr-1"></span>
                <span v-if="isSort">閲覧日時の古い順</span>
                <span v-if="!isSort">閲覧日時の新しい順</span>
              </a-button>
            </div>
            <div class="item-pagination">
              <div class="w-1/4 sm:w-full flex items-center">
                <strong>{{totalResults}}</strong>件中 1～10件表示
              </div>
              <Pagination
                class="sm:w-full pt-2 pb-2 flex justify-center sm:hidden"
                :page="page"
                @onChange="getPanigationResults"
                :totalRecord="totalResults"
              />
            </div>
          </a-card>
          <div v-if="dataList.length">
            <a-card
              class="base-content-item"
              v-for="(item, index) in dataList"
              :key="`view-list-${index}`"
            >
              <div class="thumbnail" >
                <img :src="getImageUrl(item)" class="thumbnail" />
              </div>
              <div class="base-content-item-content">
                <div class="top">
                  <div class="tag">{{getCategoryNm(item)}}</div>
                  <div>メニューNo. {{ getMenuNo(item) }}</div>
                </div>
                <div class="title text-epip">{{ getMenuNm(item) }}</div>
                <div target="_blank">
                  <span v-if="getAreaName(item)" class="icon icon-bor-pin"></span>
                  <span class="pl-2">{{getAreaName(item)}}</span>
                </div>
                <div class="base-content-item-content-footer">
                  <a @click="showModalDelete(item.id)">
                    <img
                      class="icon-trash"
                      src="@/assets/images/Symbols_2.png"
                      alt=""
                    />
                    <span class="text-span">削除</span>
                  </a>
                  <div class="flex gap-x-4">
                    <a @click="addInFavoriteList(getMenuNo(item))">
                      <i class="icon icon-bor-heart mr-1" v-if="!item.favourite">
                        <span class="text-span">お気に入りに追加</span>
                      </i>
                    </a>
                    <a @click="removeInFavoriteList(item.idFavourite)">
                      <i class="icon icon-bor-heart-solid mr-1" v-if="item.favourite">
                        <span class="text-span">お気に入り追加済</span>
                      </i>
                    </a>
                  </div>
                </div>
              </div>
            </a-card>
          </div>
          <div v-else class="mb-2">
            <a-card style="text-align: center" >該当するお知らせはありません。</a-card>
          </div>
          <a-card class="base-content-bottom">
            <div class="item-pagination">
              <div class="w-1/4 sm:w-full flex items-center">
                <strong>{{totalResults}}</strong>件中 1～10件表示
              </div>
              <Pagination
                class="sm:w-full pt-2 pb-2 flex justify-center"
                :page="page"
                @onChange="getPanigationResults"
                :totalRecord="totalResults"
              />
            </div>
          </a-card>
        </div>
      </div>
    </div>
    <div>
      <a-modal
        title=""
        ok-text="削除"
        cancel-text="キャンセル"
        :visible="visiblePopupDelete"
        @ok="handleOk"
        @cancel="handleCancel"
      >
        <p>お気に入り一覧に削除してよろしいでしょうか？</p>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { LeftMenuBar } from '@/components/compound'
import { Pagination } from '@/components/primitive'
import { GET_VIEWED_LIST_HISTORY, SAVE_FAVORITE, REMOVE_ITEM_IN_LIST, DELETE_FAVORITE } from '@/store/modules/bs_myp/actions'
import { BREADCRUMBS } from '@/store/modules/app/actions'
import _ from 'lodash'
const PLACEHOLDER_IMG = require('@/assets/images/slide-img-placeholder.png')


export default {
  components: {
    LeftMenuBar,
    Pagination
  },
  data() {
    return {
      totalResults: 0,
      breadcrumbs: [],
      isSort: false,
      inCategoryList: false,
      breadcrumb_data: ['トップ', 'マイページ', '閲覧履歴'],
      page: 1,
      dataList: [],
      visiblePopupDelete: false,
      confirmLoading: false,
      itemDelete: null,
      visiblePopupMylist: false,
      myList1: null,
      itemAddMylist: null,
      showAddMylist: false,
      textCategorylist: '',
      categoryList: [],
      currentPage: 1,
      navBars: [
        { path: '/mypage', name: 'マイページトップ' },
        { type: 'divider' },
        { path: '/mypage/benepo-history', name: '総保有ベネポ・ベネポ履歴' },
        { path: '/mypage/benepo-collect', name: '獲得予定のベネポ' },
        { type: 'divider' },
        { path: '/mypage/coupons', name: '専用ポイント・補助クーポン' },
        { type: 'divider' },
        { path: 'bs-myp-02-001', name: 'マイクーポン' },
        { path: 'bs-myp-02-010', name: '過去のクーポン' },
        { type: 'divider' },
        { path: '/mypage/orders', name: 'お申し込み履歴' },
        { path: '', name: '給トク払いご利用履歴', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '/mypage/visits', name: '閲覧履歴' },
        { type: 'divider' },
        { path: '/mypage/favorites', name: 'お気に入りメニュー' },
        { type: 'divider' },
        { path: '/mypage/setting', name: '会員プロフィール', icon: 'icon-bor-copy' },
        { path: '', name: 'メール受信・通知', icon: 'icon-bor-copy' },
        { path: '', name: 'クレジットカード', icon: 'icon-bor-copy' },
        { type: 'divider' },
        { path: '', name: '家族アカウント管理', icon: 'icon-bor-copy' }
      ]
    }
  },
  watch: {
    visiblePopupMylist() {
      if(!this.visiblePopupMylist) {
        this.showAddMylist = false
      }
    }
  },
  beforeMount() {
    this.breadcrumbs = _.cloneDeep(_.get(this.$route, 'meta.breadcrumbs', []))
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  mounted() {
    if (this.loggedIn) {
      this.getViewedListHistory()
      // update breadcrumbs
      const mybreadcrumbs = 
      {
        path: '/mypage/visits',
        title: '閲覧履歴'
      }
      this.breadcrumbs.push(mybreadcrumbs)
      this.$store.dispatch(BREADCRUMBS, this.breadcrumbs)
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  },
  methods: {
    getCategoryNm(item) {
      const catLrgClassNm = _.get(item, 'menuDetailResponse.categoryInfomation.catLrgClassNm', '')
      const catMidClassNm = _.get(item, 'menuDetailResponse.categoryInfomation.catMidClassNm', '')
      const catSmlClassNm = _.get(item, 'menuDetailResponse.categoryInfomation.catSmlClassNm', '')

      if(!catLrgClassNm && !catMidClassNm && catSmlClassNm) {
        return catSmlClassNm
      }
      if(!catLrgClassNm && catMidClassNm && !catSmlClassNm) {
        return catMidClassNm
      }
      if(catLrgClassNm && !catMidClassNm && catSmlClassNm) {
        return catLrgClassNm
      }
      if(!catLrgClassNm && catMidClassNm  && catSmlClassNm) {
        return `${catMidClassNm}・${catSmlClassNm}`
      }
      if(catLrgClassNm && !catMidClassNm && catSmlClassNm) {
        return `${catLrgClassNm}・${catSmlClassNm}`
      }
      if(catLrgClassNm && catMidClassNm && !catSmlClassNm) {
        return `${catLrgClassNm}・${ catMidClassNm}`
      }
      if(catLrgClassNm && catMidClassNm && catSmlClassNm) {
        return `${catLrgClassNm}・${catMidClassNm}・${catSmlClassNm}`
      }
      if(catLrgClassNm && !catMidClassNm && !catSmlClassNm) {
        return `${ catLrgClassNm}`
      }
    },
    getImageUrl(item) {
      const imageUrl = _.get(item, 'menuDetailResponse.menuImages[0].imageUrl', null)
      if (imageUrl) {
        return imageUrl
      }
      return PLACEHOLDER_IMG
    },
    getMenuNo(item) {
      return _.get(item, 'menuDetailResponse.menuNo', '')
    },
    getMenuNm(item) {
      return _.get(item, 'menuDetailResponse.menuNm', '')
    },
    getAreaName(item) {
      const areaMidClassNm = _.get(item, 'menuDetailResponse.areaInfomation.areaMidClassNm', '')
      const areaDtlClassNm = _.get(item, 'menuDetailResponse.areaInfomation.areaDtlClassNm', '')
      if(areaMidClassNm && areaDtlClassNm) {
        return `${areaMidClassNm} > ${areaDtlClassNm}`
      }
      if(areaMidClassNm && !areaDtlClassNm) {
        return `${areaMidClassNm}`
      }
      if(!areaMidClassNm && areaDtlClassNm) {
        return `${areaDtlClassNm}`
      }
      return ''
    },
    getInfoTokyoInn() {

    },
    getViewedListHistory() {
      const params = {
        itemType: 'viewed',
        page: 0,
        size: 10
      }
      this.$store.dispatch(GET_VIEWED_LIST_HISTORY, params).then((data) => {
        if (data && Array.isArray(data.content)) {
          this.totalResults = data.content.length
          this.dataList = data.content.map(item => {
            item.menuDetailResponse = JSON.parse(item.menuDetailResponse)
            return item
          })
        }
      })
    },
    getPanigationResults(val) {
      this.currentPage = val ? val : this.currentPage
      const params = {
        itemType: 'viewed',
        page: this.currentPage - 1,
        size: 10
      }
      this.$store.dispatch(GET_VIEWED_LIST_HISTORY, params).then((data) => {
        if (data && Array.isArray(data.content)) {
          this.totalResults = data.content.length
          this.dataList = data.content.map(item => {
            item.menuDetailResponse = JSON.parse(item.menuDetailResponse)
            return item
          })
        }
      })
    },
    addInFavoriteList(menuNo) {
      const data = {
        itemType: 'favourite', 
        menuNo
      }
      this.getPanigationResults()
      this.$store.dispatch(SAVE_FAVORITE, data).then(() => {
        this.getPanigationResults(this.currentPage)
      })
    },
    removeInFavoriteList(menuNo) {
      this.$store.dispatch(DELETE_FAVORITE, menuNo).then(() => {
        this.getPanigationResults(this.currentPage)
      })
    },
    deleteItemInList(id) {
      this.$store.dispatch(REMOVE_ITEM_IN_LIST, id).then(() => {
        this.getPanigationResults(this.currentPage)
        this.visiblePopupDelete = false
      })
    },
    getSortResults() {
      let sort = 'dateAdded,asc'
      if(this.isSort) {
        sort = 'dateAdded,asc'
      }else{
        sort = 'dateAdded,desc'
      }
      const params = {
        itemType: 'viewed',
        page: this.currentPage - 1,
        size: 10,
        sort
      }
      this.$store.dispatch(GET_VIEWED_LIST_HISTORY, params).then((data) => {
        this.isSort = !this.isSort
        if (data && Array.isArray(data.content)) {
          this.totalResults = data.content.length
          this.dataList = data.content.map(item => {
            item.menuDetailResponse = JSON.parse(item.menuDetailResponse)
            return item
          })
        }
      })
    },
    showModalDelete($event) {
      this.itemDelete = $event
      this.visiblePopupDelete = true
    },
    handleOk() {
      this.deleteItemInList(this.itemDelete)
    },
    handleCancel() {
      this.visiblePopupDelete = false
    }
    // openMap(item) {
    //   const latitude = _.get(item, 'menuDetailResponse.areaInfomation.latitude', '')
    //   const longitude = _.get(item, 'menuDetailResponse.areaInfomation.longitude', '')
    //   if (latitude && longitude) {
    //     window.open(`https://maps.google.com/?q=${latitude},${longitude}`)
    //   }
    // }
  }
}
</script>

<style lang="scss">
@import "./style.scss";

.ant-modal-footer button + button{
  letter-spacing: -2px;
}

</style>
